// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderWithScrollBodyView_root__1O0ah","body":"HeaderWithScrollBodyView_body__2US60"};